export default __webpack_public_path__ + "static/media/mute.bc9858ee.svg";